<template>
  <nav>
    <router-link to="/"></router-link> 
    <!-- <router-link to="/leftnav">leftnav</router-link> |
    <router-link to="/about">About</router-link> -->
  </nav>
  <router-view/>
  <GlobalNotification />
</template>

<script setup>
import { onMounted } from 'vue'
//消息通知提醒
import GlobalNotification from '@/components/GlobalNotification.vue'
import useWebSocket from '@/api/websocket'

const { connect, disconnect } = useWebSocket()

onMounted(() => {
  connect()
})
</script>

<style>
  
</style>
